.femLayoutFrame {
  display: flex;
  flex-flow: column nowrap;

  margin: 12px 0 20px;
}

.topBar {
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  padding: 1px 16px;
}

.left {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: flex-start;
}
